import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from '../core/services/alert.service';
import { StatePersistService } from '../core/services/state-persist.service';
import { HomeService } from '../home/services/home.service';
import { SharedConsts } from '../shared/constants';
import { GoogleAnalyticsService } from '../shared/services/google-analytics.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';


@Component({
    selector: 'app-promotion',
    templateUrl: './promotion.component.html',
    styleUrls: ['./promotion.component.scss'],
    standalone: false
})
export class PromotionComponent implements OnInit {
  bsModalRef: BsModalRef;
  promotions: any = [];
  componentLoaded = false;
  constructor(private homeService: HomeService, private toastService:AlertService,private modalService: BsModalService,
    private googleAnalyticsService: GoogleAnalyticsService, private router: Router,
    private statePersiste : StatePersistService, private alertService: AlertService) { }

  ngOnInit(): void {
    this.webPromoBanner()
    this.statePersiste.watchPromotionStorage().subscribe(() => {
      this.webPromoBanner()
    })
  }

  webPromoBanner(){
    this.componentLoaded = false;
    this.homeService.webPromoBanner()
      .subscribe(
        data => {
          if (data.response) {
            let images_array = [];
            let images;
            images = data.response.promo_banners
            for (let i = 0; i < images.length; i++) {
              images_array.push(images[i])
            }
            this.promotions = images_array
            this.componentLoaded = true
          }
        }
      )
      }
  
  viewPromotionsProducts(url, rule_id){
    this.googleAnalyticsService.eventEmitter(SharedConsts.PROMOTION_VIEW_PRODUCTS_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,SharedConsts.PROMOTION_VIEW_PRODUCTS_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.router.navigate([url+rule_id])
  }
  addDeal(rule_id){
    var dataObj = {'rule_id':rule_id}
    this.googleAnalyticsService.eventEmitter(SharedConsts.PROMOTION_ADD_DEAL_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.PROMOTION_ADD_DEAL_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.homeService.addDeal(dataObj).subscribe({
      next: (data) => {
        if (data.status == 1180) {
          localStorage.setItem('closeStorInfoMessage', data.response.msg)
          document.getElementById("openclosedStoreInfo").click();
        }
        else if (data.status == 2212) {
          this.alertService.error(data.response)
          this.webPromoBanner()
        }
        else if (data.status == 1165) {
          this.toastService.error('Some of the products of the promotion are not available now.')
          this.webPromoBanner()
        }
        else if (data.status == 403 || data.status == 1151 || data.status == 1163) {
          this.toastService.error(data.response)
          this.webPromoBanner()
        }
        else {
          for (let i = 0; i < this.promotions.length; i++) {
            if (this.promotions[i]['rule_id'] == rule_id) {
              this.promotions[i]['is_promotion_applied'] = 1
              this.promotions[i]['promotion_applied_count'] = data.response.promotion_applied_count ? data.response.promotion_applied_count : 0
            }}
          this.toastService.success('Deal Applied Sucessfully.')
          this.statePersiste.emitminiCartData('update mini cart')
        }
      }, error: (err) => {
        this.webPromoBanner()
      }
    })

  }

  onChangePromotionCount(promotion,event,template: TemplateRef<any>,index){
    if(event == 0){
      this.promotions[index].promotion_applied_count = 0
      this.bsModalRef = this.modalService.show(template,  Object.assign({}, {class: 'modal-dialog-centered custom-modal confirm' , backdrop:  'static' as 'static', keyboard: false, initialState : promotion.rule_id}));
    }
    else if(event < promotion.promotion_applied_count){
      let originalCount = this.promotions[index].promotion_applied_count
      this.promotions[index].promotion_applied_count = this.promotions[index].promotion_applied_count -1 
      this.removeDeal(promotion.rule_id,false,originalCount)
    }else{
      this.addDeal(promotion.rule_id)
    }
  }

  removeDeal(rule_id,removefullDeal,originalCount?:any){
    let dataObj = { 'rule_id': rule_id ,removefull_deal : removefullDeal}
    this.bsModalRef?.hide()
    this.googleAnalyticsService.eventEmitter(SharedConsts.PROMOTION_REMOVE_DEAL_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.PROMOTION_REMOVE_DEAL_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.homeService.removeDeal(dataObj).subscribe({
      next: (data) => {
        if (data.status == 1180) {
          localStorage.setItem('closeStorInfoMessage', data.response.msg)
          document.getElementById("openclosedStoreInfo").click();
        }
        if (data.status == 2212) {
          this.alertService.error(data.response)
          this.webPromoBanner()
        }
        else if (data.status == 1165) {
          this.toastService.error('Some of the products of the promotion are not available now.')
          this.webPromoBanner()
        }
        else if (data.status == 403 || data.status == 1151 || data.status == 1163) {
          this.toastService.error(data.response)
          this.webPromoBanner()
        }
        else {
          for (let i = 0; i < this.promotions.length; i++) {
            if (this.promotions[i]['rule_id'] == rule_id) {
              this.promotions[i]['is_promotion_applied'] = data.response?.promotion_applied_count && data.response?.promotion_applied_count > 0 ? 1 : 0
              this.promotions[i]['promotion_applied_count'] = data.response.promotion_applied_count ? data.response.promotion_applied_count : 0
            }
          }
          this.toastService.success('Deal Removed Successfully')
          this.statePersiste.emitminiCartData('update mini cart')
        }
      }, error: (err) => {
          this.toastService.error(err.error.message ? err.error.message : 'Something went wrong')
          let index = this.promotions?.findIndex(x => x.rule_id == rule_id)
          if(index > -1){
            this.promotions[index].promotion_applied_count = removefullDeal ? 1 : originalCount
          }
      }
    })
  }

  onPromotionRemovalCancel(rule_id){
    let index = this.promotions?.findIndex(x => x.rule_id == rule_id)
    if(index > -1){
      this.promotions[index].promotion_applied_count  = 1
    }
    this.bsModalRef?.hide()
  }

}
